/*
 * Free mystery gift
 *
 * Keeps exactly one gift line in the cart whenever the cart holds anything
 * else, and takes it out when the cart is otherwise empty. Configured from
 * Theme settings > Cart (see snippets/mystery-gift.liquid).
 *
 * Products reach the cart from several places (theme buttons, zerno-pdp.js,
 * the bundle builder, GemPages, apps), so rather than hooking each one this
 * watches every request to /cart/add, /cart/change, /cart/update and
 * /cart/clear and re-checks the cart after it finishes.
 */
(function () {
  var config = window.theme && window.theme.mysteryGift;
  if (!config || !config.variantId) return;

  var GIFT_ID = Number(config.variantId);
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var nativeFetch = window.fetch.bind(window);
  var running = false;
  var queued = false;
  var timer = null;

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function post(path, body) {
    return nativeFetch(root() + path, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body),
    });
  }

  function isGift(item) {
    return Number(item.variant_id) === GIFT_ID;
  }

  function addGift() {
    return post('cart/add.js', {
      items: [{id: GIFT_ID, quantity: 1, properties: {_mystery_gift: 'true'}}],
    }).then(function (r) { return r.ok; });
  }

  /*
   * Brings the cart in line with the offer. Resolves true when it changed
   * the cart, so the UI knows to redraw.
   */
  function reconcile() {
    return nativeFetch(root() + 'cart.js', {headers: {Accept: 'application/json'}})
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gifts = cart.items.filter(isGift);
        var paidCount = cart.items.filter(function (i) { return !isGift(i); }).length;
        var giftQty = gifts.reduce(function (sum, i) { return sum + i.quantity; }, 0);

        if (paidCount === 0) {
          if (giftQty === 0) return false;
          var removals = {};
          gifts.forEach(function (g) { removals[g.key] = 0; });
          return post('cart/update.js', {updates: removals}).then(function () { return true; });
        }

        if (giftQty === 0) {
          if (config.available === false) return false;
          return addGift();
        }

        // Shopify lists the newest line first in the cart and at checkout, so
        // a gift that is not on top (or got duplicated) is taken out and added
        // back to move it to the top as a single line.
        if (giftQty > 1 || !isGift(cart.items[0])) {
          var resets = {};
          gifts.forEach(function (g) { resets[g.key] = 0; });
          return post('cart/update.js', {updates: resets})
            .then(addGift)
            .then(function () { return true; });
        }

        return false;
      });
  }

  function refreshUI() {
    // The cart page is rendered server-side and has no drawer to refresh.
    if (document.querySelector('cart-element[data-cart-page]')) {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
  }

  function sync() {
    if (running) {
      queued = true;
      return;
    }
    running = true;
    reconcile()
      .then(function (changed) {
        if (changed) refreshUI();
      })
      .catch(function (error) { console.warn('[mystery-gift]', error); })
      .then(function () {
        running = false;
        if (queued) {
          queued = false;
          sync();
        }
      });
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 250);
  }

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && input.url) return input.url;
    return String(input || '');
  }

  window.fetch = function (input) {
    var request = nativeFetch.apply(window, arguments);
    if (CART_MUTATION.test(urlOf(input).split('#')[0])) {
      request.then(scheduleSync, scheduleSync);
    }
    return request;
  };

  // Some apps still use XHR (jQuery $.post etc.).
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_MUTATION.test(String(url))) {
      this.addEventListener('loadend', scheduleSync);
    }
    return nativeOpen.apply(this, arguments);
  };

  // Covers full page loads after a plain form post to /cart/add.
  scheduleSync();
})();